import { render, staticRenderFns } from "./LeadCommunicationTabs.vue?vue&type=template&id=a29aece6&scoped=true&"
import script from "./LeadCommunicationTabs.vue?vue&type=script&lang=js&"
export * from "./LeadCommunicationTabs.vue?vue&type=script&lang=js&"
import style0 from "./LeadCommunicationTabs.vue?vue&type=style&index=0&id=a29aece6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29aece6",
  null
  
)

export default component.exports